/**
 * The four Figma 06 report routes — v19 D4. The paths are the ones `nav.ts` reserved in
 * Phase 3 (`reports/received`, `reports/complete`, `billing`, `parties`), whose rows flip
 * `available: true` in the same change — a nav row and its route land together, never one
 * without the other (the five-times defect).
 */

import type { RouteObject } from 'react-router-dom';

import { BillingReportPage } from './BillingReportPage';
import { CompleteWorkReportPage } from './CompleteWorkReportPage';
import { PartiesReportPage } from './PartiesReportPage';
import { ReceivedReportPage } from './ReceivedReportPage';

export const reportRoutes: RouteObject[] = [
  { path: 'reports/received', element: <ReceivedReportPage /> },
  { path: 'reports/complete', element: <CompleteWorkReportPage /> },
  { path: 'billing', element: <BillingReportPage /> },
  { path: 'parties', element: <PartiesReportPage /> },
];
